module.exports = __webpack_public_path__ + "static/b1000x500-195c1dd57c058ae9be071a5688b5cc96.png";